var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"@768/layout/width layout/align:center layout/cursor layout/justify:center layout/width",class:[ _vm.initiallyHidden ? 'layout/none' : 'layout/flex' ],staticStyle:{"--768--layout--width":"4.8rem","--layout--width":"4.0rem"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }